import img1 from 'assets/img/content/about/tele2Altel.webp';
import img2 from 'assets/img/content/about/kcellActive.webp';
import img3 from 'assets/img/content/about/beeline.webp';

export const ABOUT_BACKGROUND_IMG = [
  {
    key: 'tele2Altel',
    url: img1
  },
  {
    key: 'kcellActive',
    url: img2
  },
  {
    key: 'beeline',
    url: img3
  }
];

export const ABOUT_LIST = [ 'about.list.0', 'about.list.1', 'about.list.2', 'about.list.3'];
